module.exports = "/assets/3b28824c67c080b96b0c647357e3d38b.png";


//////////////////
// WEBPACK FOOTER
// ./src/app/modules/flights/assets/logos/0B.png
// module id = 947
// module chunks = 0